import React from 'react';
import { AGENT_CONFIG } from '@/config/task-display-config';

const TITLE = ((AGENT_CONFIG.post_studio || {}).labels || {}).unresolvedNotesTitle || '';

/**
 * UnresolvedNotes (content-stream row R22, 21 Oct 2026) — what is still open on a draft, in plain words.
 * The server writes `unresolved_notes` as [{ kind, text }]: a statement no source passage supports and that was left
 * unknown, a fact check that read nothing, or an automatic repair that stopped for a named reason. Nothing here ends
 * the draft. Renders nothing when nothing is open.
 */
export default function UnresolvedNotes({ notes }) {
    if (!Array.isArray(notes) || notes.length === 0) return null;
    return (
        <div
            className="rounded-xl border border-amber-300 bg-amber-50 p-4 mb-4"
            role="note"
            aria-label={TITLE}
            data-testid="unresolved-notes"
        >
            <span className="text-base font-bold uppercase tracking-wide block mb-2 text-amber-900">
                {TITLE}
            </span>
            <ul className="space-y-2">
                {notes.map((n, i) => (
                    <li key={`${n.kind || 'note'}-${i}`} className="text-base text-slate-900">
                        {n.text}
                    </li>
                ))}
            </ul>
        </div>
    );
}
